module.exports = __webpack_public_path__ + "img/36.a73e1e96.png";